import React, { useRef, useState } from 'react'
import Tilt from 'react-parallax-tilt'
import { FaPlay, FaTimes, FaExternalLinkAlt } from 'react-icons/fa'

function ProjectCards({ title, description, tags, liveLink, image, video }) {
  const [open, setOpen] = useState(false)
  const previewRef = useRef(null)
  const hasMedia = Boolean(image || video)

  const spot = e => {
    const r = e.currentTarget.getBoundingClientRect()
    e.currentTarget.style.setProperty('--mx', `${e.clientX - r.left}px`)
    e.currentTarget.style.setProperty('--my', `${e.clientY - r.top}px`)
  }

  const playPreview = () => previewRef.current && previewRef.current.play().catch(() => {})
  const stopPreview = () => {
    const v = previewRef.current
    if (v) { v.pause(); v.currentTime = 0 }
  }

  return (
    <>
      <Tilt
        tiltMaxAngleX={6}
        tiltMaxAngleY={6}
        glareEnable
        glareMaxOpacity={0.12}
        glareColor="#a78bda"
        glareBorderRadius="16px"
        scale={1.02}
        transitionSpeed={900}
        style={{ height: '100%' }}
      >
        <div className="sticky-card spotlight" onMouseMove={spot} onMouseEnter={playPreview} onMouseLeave={stopPreview}>
          <div className="sticky-tape" />
          {hasMedia && (
            <button
              type="button"
              className="card-media"
              onClick={() => setOpen(true)}
              aria-label={`Open ${title} preview`}
            >
              {video ? (
                <video ref={previewRef} src={video} poster={image} muted loop playsInline preload="metadata" />
              ) : (
                <img src={image} alt={`${title} screenshot`} loading="lazy" />
              )}
              <span className="card-play"><FaPlay /></span>
            </button>
          )}
          <h3 className="sticky-title">{title}</h3>
          <p className="sticky-desc">{description}</p>
          <div className="sticky-tags">
            {tags.map(tag => (
              <span key={tag} className="sticky-tag">{tag}</span>
            ))}
          </div>
        </div>
      </Tilt>

      {open && (
        <div className="media-modal" onClick={() => setOpen(false)} role="dialog" aria-modal="true" aria-label={`${title} preview`}>
          <div className="media-modal-box" onClick={e => e.stopPropagation()}>
            <button className="media-modal-close" onClick={() => setOpen(false)} aria-label="Close">
              <FaTimes />
            </button>
            {video ? (
              <video src={video} poster={image} controls autoPlay playsInline />
            ) : (
              <img src={image} alt={`${title} screenshot`} />
            )}
            <div className="media-modal-caption">
              <strong>{title}</strong>
              {liveLink && <a href={liveLink} target="_blank" rel="noreferrer">Open live <FaExternalLinkAlt /></a>}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ProjectCards
